var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1171275444(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 605,
    viewBox: "0 0 1440 605",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_601_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 9.15527e-05H-35.8333V33.6112H14.5556V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 9.15527e-05H14.5554V33.6112H64.9443V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 9.15527e-05H64.9446V33.6112H115.333V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 9.15527e-05H115.333V33.6112H165.722V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 9.15527e-05H165.722V33.6112H216.111V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 9.15527e-05H216.111V33.6112H266.5V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 9.15527e-05H266.5V33.6112H316.889V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 9.15527e-05H316.889V33.6112H367.278V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 9.15527e-05H367.278V33.6112H417.667V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 9.15527e-05H417.667V33.6112H468.056V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 9.15527e-05H468.056V33.6112H518.445V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 9.15527e-05H518.444V33.6112H568.833V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 9.15527e-05H568.833V33.6112H619.222V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 9.15527e-05H619.222V33.6112H669.611V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 9.15527e-05H669.611V33.6112H720V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 9.15527e-05H720V33.6112H770.389V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 33.6112H-35.8333V67.2224H14.5556V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 33.6112H14.5554V67.2224H64.9443V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 33.6112H64.9446V67.2224H115.333V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 33.6112H115.333V67.2224H165.722V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 33.6112H165.722V67.2224H216.111V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 33.6112H216.111V67.2224H266.5V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 33.6112H266.5V67.2224H316.889V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 33.6112H316.889V67.2224H367.278V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 33.6112H367.278V67.2224H417.667V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 33.6112H417.667V67.2224H468.056V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 33.6112H468.056V67.2224H518.445V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 33.6112H518.444V67.2224H568.833V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 33.6112H568.833V67.2224H619.222V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 33.6112H619.222V67.2224H669.611V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 33.6112H669.611V67.2224H720V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 33.6112H720V67.2224H770.389V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 67.2223H-35.8333V100.833H14.5556V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 67.2223H14.5554V100.833H64.9443V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 67.2223H64.9446V100.833H115.333V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 67.2223H115.333V100.833H165.722V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 67.2223H165.722V100.833H216.111V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 67.2223H216.111V100.833H266.5V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 67.2223H266.5V100.833H316.889V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 67.2223H316.889V100.833H367.278V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 67.2223H367.278V100.833H417.667V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 67.2223H417.667V100.833H468.056V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 67.2223H468.056V100.833H518.445V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 67.2223H518.444V100.833H568.833V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 67.2223H568.833V100.833H619.222V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 67.2223H619.222V100.833H669.611V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 67.2223H669.611V100.833H720V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 67.2223H720V100.833H770.389V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 100.833H-35.8333V134.444H14.5556V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 100.833H14.5554V134.444H64.9443V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 100.833H64.9446V134.444H115.333V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 100.833H115.333V134.444H165.722V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 100.833H165.722V134.444H216.111V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 100.833H216.111V134.444H266.5V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 100.833H266.5V134.444H316.889V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 100.833H316.889V134.444H367.278V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 100.833H367.278V134.444H417.667V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 100.833H417.667V134.444H468.056V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 100.833H468.056V134.444H518.445V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 100.833H518.444V134.444H568.833V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 100.833H568.833V134.444H619.222V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 100.833H619.222V134.444H669.611V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 100.833H669.611V134.444H720V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 100.833H720V134.444H770.389V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 134.445H-35.8333V168.056H14.5556V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 134.445H14.5554V168.056H64.9443V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 134.445H64.9446V168.056H115.333V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 134.445H115.333V168.056H165.722V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 134.445H165.722V168.056H216.111V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 134.445H216.111V168.056H266.5V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 134.445H266.5V168.056H316.889V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 134.445H316.889V168.056H367.278V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 134.445H367.278V168.056H417.667V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 134.445H417.667V168.056H468.056V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 134.445H468.056V168.056H518.445V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 134.445H518.444V168.056H568.833V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 134.445H568.833V168.056H619.222V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 134.445H619.222V168.056H669.611V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 134.445H669.611V168.056H720V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 134.445H720V168.056H770.389V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 168.056H-35.8333V201.667H14.5556V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 168.056H14.5554V201.667H64.9443V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 168.056H64.9446V201.667H115.333V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 168.056H115.333V201.667H165.722V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 168.056H165.722V201.667H216.111V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 168.056H216.111V201.667H266.5V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 168.056H266.5V201.667H316.889V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 168.056H316.889V201.667H367.278V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 168.056H367.278V201.667H417.667V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 168.056H417.667V201.667H468.056V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 168.056H468.056V201.667H518.445V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 168.056H518.444V201.667H568.833V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 168.056H568.833V201.667H619.222V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 168.056H619.222V201.667H669.611V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 168.056H669.611V201.667H720V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 168.056H720V201.667H770.389V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 201.667H-35.8333V235.278H14.5556V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 201.667H14.5554V235.278H64.9443V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 201.667H64.9446V235.278H115.333V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 201.667H115.333V235.278H165.722V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 201.667H165.722V235.278H216.111V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 201.667H216.111V235.278H266.5V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 201.667H266.5V235.278H316.889V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 201.667H316.889V235.278H367.278V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 201.667H367.278V235.278H417.667V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 201.667H417.667V235.278H468.056V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 201.667H468.056V235.278H518.445V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 201.667H518.444V235.278H568.833V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 201.667H568.833V235.278H619.222V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 201.667H619.222V235.278H669.611V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 201.667H669.611V235.278H720V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 201.667H720V235.278H770.389V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 235.278H-35.8333V268.889H14.5556V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 235.278H14.5554V268.889H64.9443V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 235.278H64.9446V268.889H115.333V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 235.278H115.333V268.889H165.722V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 235.278H165.722V268.889H216.111V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 235.278H216.111V268.889H266.5V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 235.278H266.5V268.889H316.889V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 235.278H316.889V268.889H367.278V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 235.278H367.278V268.889H417.667V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 235.278H417.667V268.889H468.056V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 235.278H468.056V268.889H518.445V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 235.278H518.444V268.889H568.833V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 235.278H568.833V268.889H619.222V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 235.278H619.222V268.889H669.611V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 235.278H669.611V268.889H720V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 235.278H720V268.889H770.389V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 268.889H-35.8333V302.5H14.5556V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 268.889H14.5554V302.5H64.9443V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 268.889H64.9446V302.5H115.333V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 268.889H115.333V302.5H165.722V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 268.889H165.722V302.5H216.111V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 268.889H216.111V302.5H266.5V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 268.889H266.5V302.5H316.889V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 268.889H316.889V302.5H367.278V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 268.889H367.278V302.5H417.667V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 268.889H417.667V302.5H468.056V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 268.889H468.056V302.5H518.445V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 268.889H518.444V302.5H568.833V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 268.889H568.833V302.5H619.222V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 268.889H619.222V302.5H669.611V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 268.889H669.611V302.5H720V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 268.889H720V302.5H770.389V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 302.5H-35.8333V336.111H14.5556V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 302.5H14.5554V336.111H64.9443V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 302.5H64.9446V336.111H115.333V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 302.5H115.333V336.111H165.722V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 302.5H165.722V336.111H216.111V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 302.5H216.111V336.111H266.5V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 302.5H266.5V336.111H316.889V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 302.5H316.889V336.111H367.278V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 302.5H367.278V336.111H417.667V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 302.5H417.667V336.111H468.056V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 302.5H468.056V336.111H518.445V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 302.5H518.444V336.111H568.833V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 302.5H568.833V336.111H619.222V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 302.5H619.222V336.111H669.611V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 302.5H669.611V336.111H720V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 302.5H720V336.111H770.389V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 336.111H-35.8333V369.722H14.5556V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 336.111H14.5554V369.722H64.9443V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 336.111H64.9446V369.722H115.333V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 336.111H115.333V369.722H165.722V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 336.111H165.722V369.722H216.111V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 336.111H216.111V369.722H266.5V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 336.111H266.5V369.722H316.889V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 336.111H316.889V369.722H367.278V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 336.111H367.278V369.722H417.667V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 336.111H417.667V369.722H468.056V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 336.111H468.056V369.722H518.445V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 336.111H518.444V369.722H568.833V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 336.111H568.833V369.722H619.222V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 336.111H619.222V369.722H669.611V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 336.111H669.611V369.722H720V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 336.111H720V369.722H770.389V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 369.722H-35.8333V403.333H14.5556V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 369.722H14.5554V403.333H64.9443V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 369.722H64.9446V403.333H115.333V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 369.722H115.333V403.333H165.722V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 369.722H165.722V403.333H216.111V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 369.722H216.111V403.333H266.5V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 369.722H266.5V403.333H316.889V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 369.722H316.889V403.333H367.278V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 369.722H367.278V403.333H417.667V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 369.722H417.667V403.333H468.056V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 369.722H468.056V403.333H518.445V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 369.722H518.444V403.333H568.833V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 369.722H568.833V403.333H619.222V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 369.722H619.222V403.333H669.611V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 369.722H669.611V403.333H720V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 369.722H720V403.333H770.389V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 403.333H-35.8333V436.944H14.5556V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 403.333H14.5554V436.944H64.9443V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 403.333H64.9446V436.944H115.333V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 403.333H115.333V436.944H165.722V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 403.333H165.722V436.944H216.111V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 403.333H216.111V436.944H266.5V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 403.333H266.5V436.944H316.889V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 403.333H316.889V436.944H367.278V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 403.333H367.278V436.944H417.667V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 403.333H417.667V436.944H468.056V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 403.333H468.056V436.944H518.445V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 403.333H518.444V436.944H568.833V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 403.333H568.833V436.944H619.222V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 403.333H619.222V436.944H669.611V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 403.333H669.611V436.944H720V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 403.333H720V436.944H770.389V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 436.945H-35.8333V470.556H14.5556V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 436.945H14.5554V470.556H64.9443V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 436.945H64.9446V470.556H115.333V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 436.945H115.333V470.556H165.722V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 436.945H165.722V470.556H216.111V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 436.945H216.111V470.556H266.5V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 436.945H266.5V470.556H316.889V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 436.945H316.889V470.556H367.278V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 436.945H367.278V470.556H417.667V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 436.945H417.667V470.556H468.056V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 436.945H468.056V470.556H518.445V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 436.945H518.444V470.556H568.833V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 436.945H568.833V470.556H619.222V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 436.945H619.222V470.556H669.611V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 436.945H669.611V470.556H720V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 436.945H720V470.556H770.389V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 470.556H-35.8333V504.167H14.5556V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 470.556H14.5554V504.167H64.9443V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 470.556H64.9446V504.167H115.333V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 470.556H115.333V504.167H165.722V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 470.556H165.722V504.167H216.111V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 470.556H216.111V504.167H266.5V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 470.556H266.5V504.167H316.889V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 470.556H316.889V504.167H367.278V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 470.556H367.278V504.167H417.667V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 470.556H417.667V504.167H468.056V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 470.556H468.056V504.167H518.445V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 470.556H518.444V504.167H568.833V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 470.556H568.833V504.167H619.222V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 470.556H619.222V504.167H669.611V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 470.556H669.611V504.167H720V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 470.556H720V504.167H770.389V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 504.167H-35.8333V537.778H14.5556V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 504.167H14.5554V537.778H64.9443V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 504.167H64.9446V537.778H115.333V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 504.167H115.333V537.778H165.722V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 504.167H165.722V537.778H216.111V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 504.167H216.111V537.778H266.5V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 504.167H266.5V537.778H316.889V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 504.167H316.889V537.778H367.278V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 504.167H367.278V537.778H417.667V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 504.167H417.667V537.778H468.056V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 504.167H468.056V537.778H518.445V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 504.167H518.444V537.778H568.833V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 504.167H568.833V537.778H619.222V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 504.167H619.222V537.778H669.611V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 504.167H669.611V537.778H720V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 504.167H720V537.778H770.389V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 537.778H-35.8333V571.389H14.5556V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 537.778H14.5554V571.389H64.9443V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 537.778H64.9446V571.389H115.333V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 537.778H115.333V571.389H165.722V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 537.778H165.722V571.389H216.111V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 537.778H216.111V571.389H266.5V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 537.778H266.5V571.389H316.889V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 537.778H316.889V571.389H367.278V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 537.778H367.278V571.389H417.667V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 537.778H417.667V571.389H468.056V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 537.778H468.056V571.389H518.445V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 537.778H518.444V571.389H568.833V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 537.778H568.833V571.389H619.222V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 537.778H619.222V571.389H669.611V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 537.778H669.611V571.389H720V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 537.778H720V571.389H770.389V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 571.389H-35.8333V605H14.5556V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 571.389H14.5554V605H64.9443V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 571.389H64.9446V605H115.333V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 571.389H115.333V605H165.722V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 571.389H165.722V605H216.111V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 571.389H216.111V605H266.5V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 571.389H266.5V605H316.889V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 571.389H316.889V605H367.278V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 571.389H367.278V605H417.667V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 571.389H417.667V605H468.056V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 571.389H468.056V605H518.445V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 571.389H518.444V605H568.833V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 571.389H568.833V605H619.222V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 571.389H619.222V605H669.611V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 571.389H669.611V605H720V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 571.389H669.611V605H720V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 571.389H720V605H770.389V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5556 605H-35.8333V638.611H14.5556V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9443 605H14.5554V638.611H64.9443V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.333 605H64.9446V638.611H115.333V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.722 605H115.333V638.611H165.722V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.111 605H165.722V638.611H216.111V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.5 605H216.111V638.611H266.5V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.889 605H266.5V638.611H316.889V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.278 605H316.889V638.611H367.278V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.667 605H367.278V638.611H417.667V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.056 605H417.667V638.611H468.056V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.445 605H468.056V638.611H518.445V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.833 605H518.444V638.611H568.833V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.222 605H568.833V638.611H619.222V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.611 605H619.222V638.611H669.611V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 605H669.611V638.611H720V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.389 605H720V638.611H770.389V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_601_102)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M771.389 0H721V33.6111H771.389V0Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 9.15527e-05H771.389V33.6112H821.778V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 9.15527e-05H821.778V33.6112H872.167V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 9.15527e-05H872.167V33.6112H922.555V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 9.15527e-05H922.556V33.6112H972.945V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 9.15527e-05H972.944V33.6112H1023.33V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 9.15527e-05H1023.33V33.6112H1073.72V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 9.15527e-05H1073.72V33.6112H1124.11V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 9.15527e-05H1124.11V33.6112H1174.5V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 9.15527e-05H1174.5V33.6112H1224.89V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 9.15527e-05H1224.89V33.6112H1275.28V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 9.15527e-05H1275.28V33.6112H1325.67V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 9.15527e-05H1325.67V33.6112H1376.06V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 9.15527e-05H1376.06V33.6112H1426.45V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 9.15527e-05H1426.44V33.6112H1476.83V9.15527e-05Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 33.6112H721V67.2224H771.389V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 33.6112H771.389V67.2224H821.778V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 33.6112H821.778V67.2224H872.167V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 33.6112H872.167V67.2224H922.555V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 33.6112H922.556V67.2224H972.945V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 33.6112H972.944V67.2224H1023.33V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 33.6112H1023.33V67.2224H1073.72V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 33.6112H1073.72V67.2224H1124.11V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 33.6112H1124.11V67.2224H1174.5V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 33.6112H1174.5V67.2224H1224.89V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 33.6112H1224.89V67.2224H1275.28V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 33.6112H1275.28V67.2224H1325.67V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 33.6112H1325.67V67.2224H1376.06V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 33.6112H1376.06V67.2224H1426.45V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 33.6112H1426.44V67.2224H1476.83V33.6112Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 67.2223H721V100.833H771.389V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 67.2223H771.389V100.833H821.778V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 67.2223H821.778V100.833H872.167V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 67.2223H872.167V100.833H922.555V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 67.2223H922.556V100.833H972.945V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 67.2223H972.944V100.833H1023.33V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 67.2223H1023.33V100.833H1073.72V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 67.2223H1073.72V100.833H1124.11V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 67.2223H1124.11V100.833H1174.5V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 67.2223H1174.5V100.833H1224.89V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 67.2223H1224.89V100.833H1275.28V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 67.2223H1275.28V100.833H1325.67V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 67.2223H1325.67V100.833H1376.06V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 67.2223H1376.06V100.833H1426.45V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 67.2223H1426.44V100.833H1476.83V67.2223Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 100.833H721V134.444H771.389V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 100.833H771.389V134.444H821.778V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 100.833H821.778V134.444H872.167V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 100.833H872.167V134.444H922.555V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 100.833H922.556V134.444H972.945V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 100.833H972.944V134.444H1023.33V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 100.833H1023.33V134.444H1073.72V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 100.833H1073.72V134.444H1124.11V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 100.833H1124.11V134.444H1174.5V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 100.833H1174.5V134.444H1224.89V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 100.833H1224.89V134.444H1275.28V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 100.833H1275.28V134.444H1325.67V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 100.833H1325.67V134.444H1376.06V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 100.833H1376.06V134.444H1426.45V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 100.833H1426.44V134.444H1476.83V100.833Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 134.445H721V168.056H771.389V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 134.445H771.389V168.056H821.778V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 134.445H821.778V168.056H872.167V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 134.445H872.167V168.056H922.555V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 134.445H922.556V168.056H972.945V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 134.445H972.944V168.056H1023.33V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 134.445H1023.33V168.056H1073.72V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 134.445H1073.72V168.056H1124.11V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 134.445H1124.11V168.056H1174.5V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 134.445H1174.5V168.056H1224.89V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 134.445H1224.89V168.056H1275.28V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 134.445H1275.28V168.056H1325.67V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 134.445H1325.67V168.056H1376.06V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 134.445H1376.06V168.056H1426.45V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 134.445H1426.44V168.056H1476.83V134.445Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 168.056H721V201.667H771.389V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 168.056H771.389V201.667H821.778V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 168.056H821.778V201.667H872.167V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 168.056H872.167V201.667H922.555V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 168.056H922.556V201.667H972.945V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 168.056H972.944V201.667H1023.33V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 168.056H1023.33V201.667H1073.72V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 168.056H1073.72V201.667H1124.11V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 168.056H1124.11V201.667H1174.5V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 168.056H1174.5V201.667H1224.89V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 168.056H1224.89V201.667H1275.28V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 168.056H1275.28V201.667H1325.67V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 168.056H1325.67V201.667H1376.06V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 168.056H1376.06V201.667H1426.45V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 168.056H1426.44V201.667H1476.83V168.056Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 201.667H721V235.278H771.389V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 201.667H771.389V235.278H821.778V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 201.667H821.778V235.278H872.167V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 201.667H872.167V235.278H922.555V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 201.667H922.556V235.278H972.945V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 201.667H972.944V235.278H1023.33V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 201.667H1023.33V235.278H1073.72V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 201.667H1073.72V235.278H1124.11V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 201.667H1124.11V235.278H1174.5V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 201.667H1174.5V235.278H1224.89V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 201.667H1224.89V235.278H1275.28V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 201.667H1275.28V235.278H1325.67V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 201.667H1325.67V235.278H1376.06V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 201.667H1376.06V235.278H1426.45V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 201.667H1426.44V235.278H1476.83V201.667Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 235.278H721V268.889H771.389V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 235.278H771.389V268.889H821.778V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 235.278H821.778V268.889H872.167V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 235.278H872.167V268.889H922.555V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 235.278H922.556V268.889H972.945V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 235.278H972.944V268.889H1023.33V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 235.278H1023.33V268.889H1073.72V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 235.278H1073.72V268.889H1124.11V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 235.278H1124.11V268.889H1174.5V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 235.278H1174.5V268.889H1224.89V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 235.278H1224.89V268.889H1275.28V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 235.278H1275.28V268.889H1325.67V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 235.278H1325.67V268.889H1376.06V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 235.278H1376.06V268.889H1426.45V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 235.278H1426.44V268.889H1476.83V235.278Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 268.889H721V302.5H771.389V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 268.889H771.389V302.5H821.778V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 268.889H821.778V302.5H872.167V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 268.889H872.167V302.5H922.555V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 268.889H922.556V302.5H972.945V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 268.889H972.944V302.5H1023.33V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 268.889H1023.33V302.5H1073.72V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 268.889H1073.72V302.5H1124.11V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 268.889H1124.11V302.5H1174.5V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 268.889H1174.5V302.5H1224.89V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 268.889H1224.89V302.5H1275.28V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 268.889H1275.28V302.5H1325.67V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 268.889H1325.67V302.5H1376.06V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 268.889H1376.06V302.5H1426.45V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 268.889H1426.44V302.5H1476.83V268.889Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 302.5H721V336.111H771.389V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 302.5H771.389V336.111H821.778V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 302.5H821.778V336.111H872.167V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 302.5H872.167V336.111H922.555V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 302.5H922.556V336.111H972.945V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 302.5H972.944V336.111H1023.33V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 302.5H1023.33V336.111H1073.72V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 302.5H1073.72V336.111H1124.11V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 302.5H1124.11V336.111H1174.5V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 302.5H1174.5V336.111H1224.89V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 302.5H1224.89V336.111H1275.28V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 302.5H1275.28V336.111H1325.67V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 302.5H1325.67V336.111H1376.06V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 302.5H1376.06V336.111H1426.45V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 302.5H1426.44V336.111H1476.83V302.5Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 336.111H721V369.722H771.389V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 336.111H771.389V369.722H821.778V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 336.111H821.778V369.722H872.167V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 336.111H872.167V369.722H922.555V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 336.111H922.556V369.722H972.945V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 336.111H972.944V369.722H1023.33V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 336.111H1023.33V369.722H1073.72V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 336.111H1073.72V369.722H1124.11V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 336.111H1124.11V369.722H1174.5V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 336.111H1174.5V369.722H1224.89V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 336.111H1224.89V369.722H1275.28V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 336.111H1275.28V369.722H1325.67V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 336.111H1325.67V369.722H1376.06V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 336.111H1376.06V369.722H1426.45V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 336.111H1426.44V369.722H1476.83V336.111Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 369.722H721V403.333H771.389V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 369.722H771.389V403.333H821.778V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 369.722H821.778V403.333H872.167V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 369.722H872.167V403.333H922.555V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 369.722H922.556V403.333H972.945V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 369.722H972.944V403.333H1023.33V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 369.722H1023.33V403.333H1073.72V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 369.722H1073.72V403.333H1124.11V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 369.722H1124.11V403.333H1174.5V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 369.722H1174.5V403.333H1224.89V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 369.722H1224.89V403.333H1275.28V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 369.722H1275.28V403.333H1325.67V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 369.722H1325.67V403.333H1376.06V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 369.722H1376.06V403.333H1426.45V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 369.722H1426.44V403.333H1476.83V369.722Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 403.333H721V436.944H771.389V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 403.333H771.389V436.944H821.778V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 403.333H821.778V436.944H872.167V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 403.333H872.167V436.944H922.555V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 403.333H922.556V436.944H972.945V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 403.333H972.944V436.944H1023.33V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 403.333H1023.33V436.944H1073.72V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 403.333H1073.72V436.944H1124.11V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 403.333H1124.11V436.944H1174.5V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 403.333H1174.5V436.944H1224.89V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 403.333H1224.89V436.944H1275.28V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 403.333H1275.28V436.944H1325.67V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 403.333H1325.67V436.944H1376.06V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 403.333H1376.06V436.944H1426.45V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 403.333H1426.44V436.944H1476.83V403.333Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 436.945H721V470.556H771.389V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 436.945H771.389V470.556H821.778V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 436.945H821.778V470.556H872.167V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 436.945H872.167V470.556H922.555V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 436.945H922.556V470.556H972.945V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 436.945H972.944V470.556H1023.33V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 436.945H1023.33V470.556H1073.72V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 436.945H1073.72V470.556H1124.11V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 436.945H1124.11V470.556H1174.5V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 436.945H1174.5V470.556H1224.89V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 436.945H1224.89V470.556H1275.28V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 436.945H1275.28V470.556H1325.67V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 436.945H1325.67V470.556H1376.06V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 436.945H1376.06V470.556H1426.45V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 436.945H1426.44V470.556H1476.83V436.945Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 470.556H721V504.167H771.389V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 470.556H771.389V504.167H821.778V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 470.556H821.778V504.167H872.167V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 470.556H872.167V504.167H922.555V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 470.556H922.556V504.167H972.945V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 470.556H972.944V504.167H1023.33V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 470.556H1023.33V504.167H1073.72V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 470.556H1073.72V504.167H1124.11V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 470.556H1124.11V504.167H1174.5V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 470.556H1174.5V504.167H1224.89V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 470.556H1224.89V504.167H1275.28V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 470.556H1275.28V504.167H1325.67V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 470.556H1325.67V504.167H1376.06V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 470.556H1376.06V504.167H1426.45V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 470.556H1426.44V504.167H1476.83V470.556Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 504.167H721V537.778H771.389V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 504.167H771.389V537.778H821.778V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 504.167H821.778V537.778H872.167V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 504.167H872.167V537.778H922.555V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 504.167H922.556V537.778H972.945V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 504.167H972.944V537.778H1023.33V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 504.167H1023.33V537.778H1073.72V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 504.167H1073.72V537.778H1124.11V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 504.167H1124.11V537.778H1174.5V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 504.167H1174.5V537.778H1224.89V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 504.167H1224.89V537.778H1275.28V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 504.167H1275.28V537.778H1325.67V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 504.167H1325.67V537.778H1376.06V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 504.167H1376.06V537.778H1426.45V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 504.167H1426.44V537.778H1476.83V504.167Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 537.778H721V571.389H771.389V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 537.778H771.389V571.389H821.778V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 537.778H821.778V571.389H872.167V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 537.778H872.167V571.389H922.555V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 537.778H922.556V571.389H972.945V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 537.778H972.944V571.389H1023.33V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 537.778H1023.33V571.389H1073.72V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 537.778H1073.72V571.389H1124.11V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 537.778H1124.11V571.389H1174.5V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 537.778H1174.5V571.389H1224.89V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 537.778H1224.89V571.389H1275.28V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 537.778H1275.28V571.389H1325.67V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 537.778H1325.67V571.389H1376.06V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 537.778H1376.06V571.389H1426.45V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 537.778H1426.44V571.389H1476.83V537.778Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 571.389H721V605H771.389V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 571.389H771.389V605H821.778V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 571.389H821.778V605H872.167V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 571.389H872.167V605H922.555V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 571.389H922.556V605H972.945V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 571.389H972.944V605H1023.33V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 571.389H1023.33V605H1073.72V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 571.389H1073.72V605H1124.11V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 571.389H1124.11V605H1174.5V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 571.389H1174.5V605H1224.89V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 571.389H1224.89V605H1275.28V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 571.389H1275.28V605H1325.67V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 571.389H1325.67V605H1376.06V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 571.389H1376.06V605H1426.45V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 571.389H1426.44V605H1476.83V571.389Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.389 605H721V638.611H771.389V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.778 605H771.389V638.611H821.778V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872.167 605H821.778V638.611H872.167V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.555 605H872.167V638.611H922.555V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.945 605H922.556V638.611H972.945V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.33 605H972.944V638.611H1023.33V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.72 605H1023.33V638.611H1073.72V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.11 605H1073.72V638.611H1124.11V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1174.5 605H1124.11V638.611H1174.5V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.89 605H1174.5V638.611H1224.89V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.28 605H1224.89V638.611H1275.28V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1325.67 605H1275.28V638.611H1325.67V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1376.06 605H1325.67V638.611H1376.06V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426.45 605H1376.06V638.611H1426.45V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.83 605H1426.44V638.611H1476.83V605Z",
    stroke: "#5E5E5E",
    strokeOpacity: 0.4,
    strokeWidth: 0.566875
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_601_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 907,
    height: 605,
    fill: "white",
    transform: "translate(-187)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_601_102"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 907,
    height: 605,
    fill: "white",
    transform: "translate(721)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1171275444);
export default __webpack_public_path__ + "static/media/Group 1171275444.507154a13dbb11cce85186903f89587e.svg";
export { ForwardRef as ReactComponent };